import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { toast, ToastBar, Toaster } from 'react-hot-toast';
import { HiX } from 'react-icons/hi';

import { useAuth } from '@/shared/hooks/context/auth';

import SquaredCheck from '~/images/shared/SquaredCheck.svg';

export default function DismissableToast() {
  const { locale } = useRouter();
  const { collapseState } = useAuth();
  const [calcWidth, setCalcWidth] = useState<string>('90vw');

  useEffect(() => {
    if (collapseState !== null) {
      if (collapseState) setCalcWidth('13.5rem');
      else setCalcWidth('5.75rem');
    } else setCalcWidth('90vw');
  }, [collapseState]);

  return (
    <div>
      <Toaster
        reverseOrder={false}
        position='top-center'
        toastOptions={{
          duration: 5000,
          style: {
            borderRadius: '16px',
            width: `calc(100% - ${calcWidth})`,
            marginRight: locale === 'ar' ? 'auto' : '',
            marginLeft: locale === 'ar' ? '' : 'auto',
            maxWidth: 'unset',
            background: '#DFECFA',
            color: '#0D2A4A',
            paddingTop: 10,
            paddingBottom: 10,
          },
          error: {
            style: {
              background: '#F9DEDC',
              color: '#083327',
            },
          },
          success: {
            icon: <SquaredCheck />,
            style: {
              background: '#D0F3E9',
              color: '#083327',
            },
          },
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                <div className='toaster-message w-full'>{message}</div>
                {t.type !== 'loading' && (
                  <button
                    className='rounded-full p-1 ring-primary-400 transition focus:outline-none focus-visible:ring hover:bg-[#12386214]'
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <HiX />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
}
